<template>
  <vue-page-wraper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Documents"
        subtitle="Here you can see the list of documents."
        :icon="$getIcon('mdiFileDocumentOutline')"
      >
        <template slot="actions">
          <v-btn
            class="mr-2 text-none"
            depressed
            small
            color="primary"
            @click="(displayForm = true), (actionData = {})"
          >
            Create New
          </v-btn>
          <v-btn icon @click="filter.show = !filter.show">
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-show="filter.show" class="mx-1 py-0">
          <v-col>
            <v-text-field
              v-model="filter.search"
              label="Search"
              :append-icon="$getIcon('mdiMagnify')"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-divider v-if="filter.show"></v-divider>
      <div>
        <v-data-table
          :headers="headers"
          :items="fetchedResults"
          :loading="loading"
          :sort-desc.sync="pagination.descending"
          :sort-by.sync="pagination.sortBy"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.rowsPerPage"
          :footer-props="footerProps"
          :server-items-length="pagination.totalItems"
          :mobile-breakpoint="0"
          must-sort
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-left">
                {{ props.item.title }}
              </td>
              <td>
                {{ props.item.type }}
              </td>
              <td class="text-center">
                <v-icon
                  v-if="props.item.is_archived"
                  color="green"
                  v-text="$getIcon('mdiCheckCircle')"
                ></v-icon>
                <v-icon
                  v-else
                  color="red"
                  v-text="$getIcon('mdiCloseCircle')"
                ></v-icon>
              </td>
              <td>
                <div>Created: {{ humanizeTime(props.item.created_at) }}</div>
                <div>Modified: {{ humanizeTime(props.item.modified_at) }}</div>
              </td>
              <td>
                <vue-context-menu
                  :context-list="[
                    {
                      name: 'View Details',
                      icon: 'mdiEyeOutline',
                      color: 'blue'
                    },
                    {
                      name: 'Edit Details',
                      icon: 'mdiPencilOutline',
                      color: 'blue'
                    }
                  ]"
                  @click0="(showViewForm = true), (actionData = props.item)"
                  @click1="(displayForm = true), (actionData = props.item)"
                ></vue-context-menu>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <data-table-no-data :loading="loading"></data-table-no-data>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog
      v-if="displayForm"
      v-model="displayForm"
      scrollable
      persistent
      max-width="960px"
    >
      <create-form
        v-if="displayForm"
        :action-data="actionData"
        @close="displayForm = false"
        @create="(displayForm = false), loadDataTableChange()"
        @update="(displayForm = false), loadDataTableChange()"
      ></create-form>
    </v-dialog>
    <v-dialog
      v-if="showViewForm"
      v-model="showViewForm"
      scrollable
      persistent
      max-width="760px"
    >
      <view-form
        v-if="showViewForm"
        :action-data="actionData"
        @close="showViewForm = false"
      ></view-form>
    </v-dialog>
  </vue-page-wraper>
</template>
<script>
import DataTableMixin from "@/mixins/newDataTableMixin";
import DataTableNoData from "@/components/common/layout_utils/DataTableNoData";
import VueContextMenu from "@/components/common/layout_utils/VueContextMenu.vue";
import CreateForm from "@/components/crm/documents/CreateDocument.vue";
import ViewForm from "@/components/crm/documents/ViewDocumentDetails";
import VuePageWraper from "@/components/common/layout_utils/VuePageWrapper.vue";
export default {
  components: {
    VuePageWraper,
    CreateForm,
    ViewForm,
    DataTableNoData,
    VueContextMenu
  },
  mixins: [DataTableMixin],
  data() {
    return {
      loading: false,
      htmlTitle: "Documents",
      breadCrumbs: [{ text: "Documents", disabled: true }],
      displayForm: false,
      showViewForm: false,
      actionData: {},
      headers: [
        { text: "Title", sortable: false, width: "25%" },
        { text: "Category", align: "", sortable: false },
        { text: "Is Archived", align: "center", sortable: false },
        { text: "Timestamp", align: "", sortable: false },
        { text: "Action", align: "", sortable: false }
      ],
      filter: {
        search: "",
        show: false
      },
      endpoint: `/api/v1/org/${this.$store.state.shell.currentOrganizationId}/documents/`
    };
  },
  computed: {
    DataTableFilter() {
      return {
        search: this.filter.search
      };
    }
  },
  created() {
    this.loadDataTableChange();
  },
  methods: {
    fetchDataTable() {
      this.loading = true;
      this.$axios
        .get(this.endpoint, {
          params: this.fullParams
        })
        .then(response => {
          this.loadDataTable(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    humanizeTime(timeStamp) {
      return timeStamp ? this.$dayjs(timeStamp).fromNow() : "N/A";
    }
  }
};
</script>
